
import Vue from "vue";
import { Assessment } from "@/interfaces/recruiter/candidates/create_assessment";
import { mapGetters, mapActions } from "vuex";
import { FETCH_AVAILABLE_APPLICANTS } from "@/store/modules/recruiter/constants";

export default Vue.extend({
  name: "AssessmentForm",
  props: {
    value: {
      type: Object as () => Assessment,
      required: true
    },
    rules: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isValid: true,
      localAssessment: {
        ...this.value,
        difficulty: this.value.difficulty.toLowerCase()
      },
      loadingApplicants: false,
      searchInput: ""
    };
  },
  computed: {
    ...mapGetters("recruiter", {
      availableApplicants: FETCH_AVAILABLE_APPLICANTS
    }),
    difficultyOptions() {
      return [
        { text: "Easy", value: "easy" },
        { text: "Medium", value: "medium" },
        { text: "Hard", value: "hard" }
      ];
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.localAssessment = {
          ...newVal,
          difficulty: newVal.difficulty.toLowerCase()
        };
      },
      deep: true
    }
  },
  methods: {
    ...mapActions("recruiter", {
      fetchAvailableApplicants: FETCH_AVAILABLE_APPLICANTS
    }),
    updateAssessment() {
      this.$emit("input", { ...this.localAssessment });
      this.onValidationChange();
    },
    onValidationChange() {
      this.$emit("validation-change", this.isValid);
    },
    async loadAvailableApplicants() {
      this.loadingApplicants = true;
      try {
        await this.fetchAvailableApplicants();
      } catch (error) {
        console.error("Error loading available applicants:", error);
        this.$store.commit("ROOT_ERROR", {
          message: "Error loading available applicants",
          type: "error"
        });
      } finally {
        this.loadingApplicants = false;
      }
    },
    getApplicantName(applicantId: string): string {
      const applicant = this.availableApplicants.find(
        (a: { value: string; label: string }) => a.value === applicantId
      );
      return applicant ? applicant.label : applicantId;
    }
  },
  async mounted() {
    await (this as any).loadAvailableApplicants();
  }
});
